if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        // the photos sit in a row: the arrows and the arrow keys step one photo, an arrow fades at the row's end
        this.content = this.querySelector('[role="document"]');
        this.steps = this.querySelectorAll('[data-modal-step]');
        this.steps.forEach((b) => {
          b.addEventListener('click', () => this.step(Number(b.dataset.modalStep)));
          b.addEventListener('pointerup', (e) => e.stopPropagation()); // ModalDialog closes a media modal on any mouse pointerup
        });
        this.addEventListener('keydown', (e) => {
          const d = { ArrowLeft: -1, ArrowRight: 1 }[e.key];
          if (!d) return;
          e.preventDefault();
          this.step(d);
        });
        this.content.addEventListener('scroll', () => this.ends(), { passive: true });
      }

      step(d) {
        this.content.scrollBy({ left: d * this.content.clientWidth, behavior: 'smooth' });
      }

      ends() {
        const c = this.content;
        if (!this.steps.length) return;
        this.steps[0].disabled = c.scrollLeft < 2;
        this.steps[1].disabled = c.scrollLeft > c.scrollWidth - c.clientWidth - 2;
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView(); // the photos sit side by side: this brings the tapped one (Dawn then re-centred a 1100 px image sideways)
        this.ends();

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
